import { z } from 'zod';
export const RequestIdSchema = z.string().trim().min(1).max(128);
export const CursorSchema = z.string().trim().min(1).max(1024);
export const ApiErrorDetailsSchema = z
    .object({
    code: z.string().trim().min(1).max(100),
    message: z.string().trim().min(1).max(1000),
    requestId: RequestIdSchema,
    details: z.unknown().optional(),
    fieldErrors: z.record(z.array(z.string())).optional(),
})
    .strict();
export const ApiErrorSchema = z
    .object({
    error: ApiErrorDetailsSchema,
})
    .strict();
export const OkResponseSchema = z.object({ ok: z.literal(true) }).strict();
export const ApiSuccessSchema = (dataSchema) => z
    .object({
    data: dataSchema,
    requestId: RequestIdSchema.optional(),
})
    .strict();
export const ApiResponseSchema = (dataSchema) => z.union([ApiSuccessSchema(dataSchema), ApiErrorSchema]);
export const CursorPageSchema = (itemSchema) => z
    .object({
    items: z.array(itemSchema),
    nextCursor: CursorSchema.nullable(),
})
    .strict();
export const CursorQuerySchema = z
    .object({
    cursor: CursorSchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
})
    .strict();
export const IdempotencyKeySchema = z.string().trim().min(8).max(128);
//# sourceMappingURL=api.js.map